import type { DigitalDataOrigin } from "../../utils/digital-data-types"

export const getDigitalDataOrigin = (displayName: string) => {
  const digitalDataOriginRep = displayName?.replace(/ /g, '') ?? ''

  return (digitalDataOriginRep?.substring(0, 1)?.toLowerCase() +
    digitalDataOriginRep?.substring(1, digitalDataOriginRep.length)) as DigitalDataOrigin
}
